// declare necessary libraries

import store from "../store";
import Utils from "../helpers/utils";

export default class SchedulingService {
  constructor() {
    this.readConfig();
  }
  // read waiting/expiry pages
  readConfig() {
    this.expiredPage = store.state.expiredPage;    
    this.waitingPage = store.state.waitingPage;
    this.config = store.state.appData.WidgetData.config;
  }

  replaceGlobally (original, searchTxt, replaceTxt) {
    const regex = new RegExp(searchTxt, 'g');
    return original.replace(regex, replaceTxt) ;
  }

  getParams(url) {
    Utils.log.debug('getParams from ' + url);
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    Utils.log.debug('getParams from ' + url + ' returns ' + JSON.stringify(params));
    return params;
  }

  isOOSShowing() {
    if (((!this.expiredPage || this.expiredPage ==='') &&
      (!this.waitingPage || this.waitingPage ==='')) || 
      !this.config) {
        Utils.log.debug('In schedule - no OOS pages/config');
      return false;
    }

    var params = this.getParams(window.location.href);

    if (!params && !params.startTime && !params.endTime) {
      Utils.log.debug('In schedule - no start/end time');
      return false;    
    }

    var now = new Date();
    var timeToWait = 0;
    var timePassed = 0;
    var checkExpiredDefault = false;
    if (params.startTime) {
      var startTime = Date.parse(params.startTime);
      timeToWait = startTime - now.getTime();
      checkExpiredDefault = true;
    }
    if (params.endTime) {
      var endTime = Date.parse(params.endTime);
      timePassed = now.getTime() - endTime;
      checkExpiredDefault = false;
    }

    if (checkExpiredDefault === true) {
      timePassed = now.getTime() - (Date.parse(params.startTime) + (this.config.expiredDefaultMins * 60000));
    }

    if (( timeToWait <= 0) && (timePassed <= 0)) {
      Utils.log.debug('In schedule - start in past / end in future');
      return false;
    }
    
    if ((timeToWait > this.config.waitingTime) && this.waitingPage && this.waitingPage!=='') {
      // The time to wait exceeds threshold - send to waiting page
      var htmlWaiting = this.waitingPage;
      htmlWaiting = this.replaceGlobally(htmlWaiting, '__ORIGURL__', encodeURIComponent(window.location.href));
      htmlWaiting = this.replaceGlobally(htmlWaiting, '__WAITINGTIME__', encodeURIComponent(this.config.waitingTime));
      document.open("");
      document.write(htmlWaiting);
      document.close();
      Utils.log.info('OOS - waiting');
      return true;
    } 
    else if ((timePassed > this.config.expiredTime) && this.expiredPage && this.expiredPage!=='' &&
     this.config.expiredContinue !== true) {
      var htmlExpired = this.expiredPage;
      htmlExpired = this.replaceGlobally(htmlExpired, '__ORIGURL__', encodeURIComponent(window.location.href));
      htmlExpired = this.replaceGlobally(htmlExpired, '__EXPIREDTIME__', encodeURIComponent(this.config.expiredTime));
      htmlExpired = this.replaceGlobally(htmlExpired, '__EXPIREDDEFAULTMINS__', encodeURIComponent(this.config.expiredDefaultMins));
      document.open("");
      document.write(htmlExpired);
      document.close();
      Utils.log.info('OOS - expired');
      return true;
    }

    Utils.log.debug('In schedule');
    return false;

  }


}